import React from 'react';
import { StatsCards } from '../../../../Components/StatsCards/StatsCards';
import { CircularStatsCards } from '../../../../Components/CircularStatsCards/CircularStatsCards';
import { LeaderboardEvent } from '../../../../api/leaderboard-events';
import { useLeaderboardSummary } from '../../../../hooks/useLeaderboardSummary';
import './ResultsSidebar.scss';

interface ResultsSidebarProps {
  selectedEvent?: LeaderboardEvent | null;
}

export const ResultsSidebar: React.FC<ResultsSidebarProps> = ({ selectedEvent }) => {
  const { summary } = useLeaderboardSummary(selectedEvent?.id);

  const progressData =
    summary && selectedEvent
      ? [
          {
            label: 'Total Hours',
            value: summary.totalHours,
            max: selectedEvent.milestone,
          },
          {
            label: 'Total Reviews',
            value: summary.reviewsCount,
            max: summary.reviewMilestone,
          },
        ]
      : undefined;

  return (
    <div className="results-sidebar">
      <StatsCards summary={summary} />
      <CircularStatsCards data={progressData} />
    </div>
  );
};
